import GalleryDetail from './components';

export default GalleryDetail;
